
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import { get } from 'lodash';

interface MessageOverlayConfig {
    title?: string,
    message?: string,
    link?: string,
    button?: {
        text?: string,
        action?: () => void
    },
}

export default Vue.extend({
    name: 'Overlay',

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        config: {
            type: Object as PropType<MessageOverlayConfig>,
            default: () => ({} as MessageOverlayConfig)
        }
    },

    computed: {
        buttonText(): string {
            return get(this.config, 'button.text', 'OK');
        },
    },

    methods: {
        click() {
            this.api.customAction({ clicked: true }, 'message-overlay');
            if (typeof (this.config?.button?.action) === 'function') {
                this.config.button.action();
            }
        },
    }

});
